import type { ComponentType, ReactNode, SVGProps } from "react";
import { Panel } from "@/components/ui/Panel";

type PortfolioPageInsightItemProps = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  text: ReactNode;
};

export function PortfolioPageInsightItem({
  icon: Icon,
  title,
  text,
}: PortfolioPageInsightItemProps) {
  return (
    <Panel variant="compact" className="flex items-start">
      <div className="icon-wrapper">
        <Icon className="size-5" />
      </div>
      <div className="space-y-0.5">
        <p className="text-xs font-semibold text-foreground">{title}</p>
        <p className="app-card-description">{text}</p>
      </div>
    </Panel>
  );
}
